/* Scubalooks – Size Helper v3 (deterministic, no server/AI needed) */

// ============ 1. Sizing logic (edit chart & rules here) ============
var ScubalooksSizing = (function () {
  // Hips decide the size. waistMax = the largest waist (cm) each size
  // stretches to comfortably; a bigger waist moves the customer one size up.
  var SIZES = [
    { code: 'XS', hip: [90, 94],   waistMax: 73 },
    { code: 'S',  hip: [95, 99],   waistMax: 77 },
    { code: 'M',  hip: [100, 107], waistMax: 82 },
    { code: 'L',  hip: [108, 113], waistMax: 92 },
    { code: 'XL', hip: [114, 121], waistMax: 92 }
  ];

  // How far (cm) outside XS–XL we still give XS/XL instead of "out of range".
  var TOLERANCE_BELOW_CM = 3;  // hips down to 87 → XS
  var TOLERANCE_ABOVE_CM = 1;  // hips up to 122 → XL
  // Stretch zone: hips up to this still get XL, with a "snatched tight" note.
  var XL_STRETCH_MAX_HIP = 127;
  // "Comfortable": go one size up when the waist is within this many cm of waistMax.
  var COMFORT_MARGIN_CM = 4;

  function parseNum(v) {
    if (v === null || v === undefined) return NaN;
    var s = String(v).trim().replace(',', '.').replace(/[^\d.]/g, '');
    return s ? parseFloat(s) : NaN;
  }

  /**
   * waist, hip: numbers or strings ("69,5" ok)
   * unit: 'cm' | 'in'
   * pref: 'comfort' | 'sculpted' | 'snatched'
   */
  function recommend(waist, hip, unit, pref) {
    var w = parseNum(waist), h = parseNum(hip);
    if (!(w > 0) || !(h > 0)) return { status: 'invalid' };

    var convertedFromInches = false;
    // cm selected but values look like inches (e.g. 28 / 38) → convert
    if (unit === 'in' || (w < 55 && h < 70)) {
      convertedFromInches = unit !== 'in';
      w = Math.round(w * 2.54 * 10) / 10;
      h = Math.round(h * 2.54 * 10) / 10;
    }

    var base = { waist: w, hip: h, convertedFromInches: convertedFromInches };
    var last = SIZES.length - 1;
    if (h < SIZES[0].hip[0] - TOLERANCE_BELOW_CM) return Object.assign({ status: 'too_small' }, base);
    if (h > XL_STRETCH_MAX_HIP) return Object.assign({ status: 'too_large' }, base);
    var stretchXL = h > SIZES[last].hip[1] + TOLERANCE_ABOVE_CM;

    // Size by hips. Values between two ranges (e.g. 99.5) go to the smaller size.
    var hipIdx = 0;
    for (var i = 0; i < SIZES.length; i++) {
      if (h >= SIZES[i].hip[0]) hipIdx = i;
    }

    // Waist bigger than the hip size stretches to → one size up (never more).
    var main = hipIdx;
    if (w > SIZES[hipIdx].waistMax) {
      if (hipIdx === last) return Object.assign({ status: 'too_large' }, base);
      main = hipIdx + 1;
    }

    // Stretch zone above XL: always XL, whatever the fit preference.
    if (stretchXL) {
      return Object.assign({
        status: 'ok', size: SIZES[last].code, mainSize: SIZES[last].code,
        snatchedSize: null, pref: 'sculpted', isSmallest: false, stretchXL: true
      }, base);
    }

    // Comfortable: one size up if the waist is close to the limit.
    var comfort = main;
    if (main === hipIdx && main < last && w > SIZES[main].waistMax - COMFORT_MARGIN_CM) comfort = main + 1;

    var snatched = main > 0 ? main - 1 : null;
    var p = (pref === 'comfort' || pref === 'snatched') ? pref : 'sculpted';
    var chosen = main;
    if (p === 'comfort') chosen = comfort;
    if (p === 'snatched' && snatched !== null) chosen = snatched;

    return Object.assign({
      status: 'ok',
      size: SIZES[chosen].code,
      mainSize: SIZES[main].code,
      snatchedSize: snatched !== null ? SIZES[snatched].code : null,
      pref: p,
      isSmallest: main === 0
    }, base);
  }

  return { SIZES: SIZES, recommend: recommend };
})();

if (typeof module !== 'undefined' && module.exports) module.exports = ScubalooksSizing;

// ============ 2. Widget UI ============
(function () {
  if (typeof document === 'undefined') return;
  try {
    var DA = (document.documentElement.getAttribute('lang') || 'en').toLowerCase().indexOf('da') === 0;
    var isMobile = window.innerWidth < 750;
    var MEASURE_IMG = 'https://cdn.shopify.com/s/files/1/0994/8846/5234/files/waist.png?v=1758469067';

    var T = DA ? {
      button: 'Størrelseshjælp',
      title: 'Find din størrelse',
      intro: 'Indtast dine mål, så finder vi din perfekte Scubalooks pasform. Perfekt pasform = færre returneringer = mere bæredygtigt 💚',
      waist: 'Talje', hip: 'Hofte',
      waistHint: 'smalleste sted', hipHint: 'bredeste sted',
      unitCm: 'cm', unitIn: 'tommer',
      prefQ: 'Hvordan kan du lide pasformen?',
      prefComfort: 'Komfortabel (lettere hold)',
      prefSculpted: 'Skulpteret (anbefalet)',
      prefSnatched: 'Super-snatched (ekstra stram)',
      submit: 'Find min størrelse',
      howLink: 'Hvor skal jeg måle?',
      noTapeLink: 'Intet målebånd?',
      how: '<strong>Talje:</strong> det smalleste sted på overkroppen – typisk lige over navlen.<br><strong>Hofte:</strong> det bredeste sted over hofter og bagdel.',
      noTape: 'Intet målebånd? Intet problem 😊<br>Tag en snor, et bånd eller en ledning. Vikl den om din talje og hofte, markér hvor den mødes, og mål længden med en lineal.',
      invalid: 'Indtast venligst både talje- og hoftemål.',
      converted: 'Dine mål lignede tommer, så vi har omregnet dem til cm.',
      tooSmall: 'Vi tilbyder i øjeblikket størrelserne XS–XL, og dine mål ligger under XS. Vi udvider snart – tilmeld dig vores nyhedsbrev for at få besked, når nye størrelser kommer.',
      tooLarge: 'Vi tilbyder i øjeblikket størrelserne XS–XL, og dine mål ligger over XL. Vi udvider snart – tilmeld dig vores nyhedsbrev for at få besked, når nye størrelser kommer.',
      best: function (s) { return 'Din bedste pasform er <strong>' + s + '</strong> for en skulpteret, flatterende form.'; },
      bestComfort: function (s) { return 'Din bedste pasform er <strong>' + s + '</strong> for en komfortabel pasform med et lettere hold om taljen.'; },
      snatchOption: function (s) { return 'Elsker du en ekstra snatched talje? Så kan du vælge ' + s + ' – den føles stram i starten, men former sig efter din krop.'; },
      snatchChosen: function (s, m) { return 'Til det super-snatched look skal du vælge <strong>' + s + '</strong>. Taljen vil føles meget stram i starten, men det højelastiske stof former sig efter din krop. Vil du have mere komfort, er ' + m + ' den skulpterede pasform.'; },
      smallest: 'XS er vores mindste størrelse og giver allerede en snatched pasform.',
      stretchXL: 'Vores største størrelse, <strong>XL</strong>, giver dig en super-snatched pasform. Forvent at den føles stram, især om taljen – det højelastiske stof former sig efter din krop. Foretrækker du en mere afslappet pasform? Tilmeld dig vores nyhedsbrev – større størrelser kommer snart.',
      inseam: 'Benlængde: 81 cm (en 86 cm version kommer snart).'
    } : {
      button: 'Size Helper',
      title: 'Find your size',
      intro: 'Enter your measurements and we\'ll find your perfect Scubalooks fit. Perfect fit = fewer returns = more sustainable 💚',
      waist: 'Waist', hip: 'Hips',
      waistHint: 'narrowest point', hipHint: 'widest point',
      unitCm: 'cm', unitIn: 'inches',
      prefQ: 'How do you like your fit?',
      prefComfort: 'Comfortable (lighter hold)',
      prefSculpted: 'Sculpted (recommended)',
      prefSnatched: 'Super-snatched (extra tight)',
      submit: 'Find my size',
      howLink: 'Where do I measure?',
      noTapeLink: 'No measuring tape?',
      how: '<strong>Waist:</strong> at the smallest part of your torso – usually just above your belly button.<br><strong>Hips:</strong> at the fullest part of your hips and bum.',
      noTape: 'No measuring tape? No problem 😊<br>Grab any string, ribbon, or cord. Wrap it around your waist and hips, mark where it meets, then measure the length with a ruler.',
      invalid: 'Please enter both your waist and hip measurements.',
      converted: 'Your numbers looked like inches, so we converted them to cm.',
      tooSmall: 'We currently offer sizes XS–XL, and your measurements are below XS. We\'re expanding soon – sign up for our newsletter to be notified when new sizes arrive.',
      tooLarge: 'We currently offer sizes XS–XL, and your measurements are above XL. We\'re expanding soon – sign up for our newsletter to be notified when new sizes arrive.',
      best: function (s) { return 'Your best fit is <strong>' + s + '</strong> for a sculpted, flattering shape.'; },
      bestComfort: function (s) { return 'Your best fit is <strong>' + s + '</strong> for a comfortable fit with a lighter hold around the waist.'; },
      snatchOption: function (s) { return 'Love an extra snatched waist? ' + s + ' is for you – it will feel tight at first, then mold to your shape.'; },
      snatchChosen: function (s, m) { return 'For the super-snatched look, choose <strong>' + s + '</strong>. The waist will feel very tight at first – the high-stretch fabric molds to your shape. For a sculpted fit with more comfort, ' + m + ' is your size.'; },
      smallest: 'XS is our smallest size and already gives a snatched fit.',
      stretchXL: 'Our largest size, <strong>XL</strong>, will give you a super-snatched fit. Expect it to feel tight, especially at the waist – the high-stretch fabric molds to your shape. Prefer a more relaxed fit? Sign up for our newsletter – larger sizes are coming soon.',
      inseam: 'Inseam: 81 cm (an 86 cm version is coming soon).'
    };

    ['#sizeGuideBubbleHost', '#sizeGuidePanel'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { el.remove(); });
    });

    // ---- Panel ----
    var panel = document.createElement('div');
    panel.id = 'sizeGuidePanel';
    Object.assign(panel.style, {
      position: 'fixed',
      bottom: isMobile ? '130px' : '150px',
      left: isMobile ? '16px' : 'auto',
      right: isMobile ? 'auto' : '20px',
      width: '340px', maxWidth: '92vw',
      maxHeight: isMobile ? 'min(70vh, calc(100vh - 150px))' : 'calc(100vh - 170px)',
      background: '#fff', color: '#222',
      borderRadius: '16px',
      boxShadow: '0 12px 30px rgba(0,0,0,.18)',
      display: 'none', flexDirection: 'column',
      overflow: 'hidden', zIndex: '99999',
      fontFamily: 'system-ui, -apple-system, sans-serif', fontSize: '14px', lineHeight: '1.4'
    });

    var inputStyle = 'width:100%;height:40px;border-radius:10px;border:1px solid #ddd;padding:0 12px;font-size:16px;box-sizing:border-box;';
    var labelStyle = 'display:block;font-weight:700;margin-bottom:4px;';
    var hintStyle = 'font-weight:400;color:#888;font-size:12px;';
    var linkStyle = 'background:none;border:none;padding:0;color:#555;text-decoration:underline;cursor:pointer;font-size:13px;';
    var radioStyle = 'display:flex;gap:8px;align-items:center;margin-bottom:4px;cursor:pointer;';

    panel.innerHTML =
      '<div style="display:flex;align-items:center;justify-content:space-between;padding:12px 14px;border-bottom:1px solid #eee;">' +
        '<strong style="font-size:15px;">' + T.title + '</strong>' +
        '<button class="sh-close" aria-label="Close" style="background:none;border:none;font-size:20px;cursor:pointer;color:#888;line-height:1;">×</button>' +
      '</div>' +
      '<style>#sizeGuidePanel > div, #sizeGuidePanel .sh-body > * { flex-shrink: 0; }</style>' +
      '<div class="sh-body" style="flex:1 1 auto;min-height:0;overflow-y:auto;padding:14px;display:flex;flex-direction:column;gap:12px;">' +
        '<div style="color:#555;">' + T.intro + '</div>' +
        '<div style="display:flex;gap:10px;">' +
          '<label style="flex:1;"><span style="' + labelStyle + '">' + T.waist + ' <span style="' + hintStyle + '">' + T.waistHint + '</span></span>' +
            '<input class="sh-waist" type="text" inputmode="decimal" autocomplete="off" style="' + inputStyle + '"></label>' +
          '<label style="flex:1;"><span style="' + labelStyle + '">' + T.hip + ' <span style="' + hintStyle + '">' + T.hipHint + '</span></span>' +
            '<input class="sh-hip" type="text" inputmode="decimal" autocomplete="off" style="' + inputStyle + '"></label>' +
        '</div>' +
        '<div class="sh-units" style="display:flex;gap:6px;">' +
          '<button type="button" data-unit="cm" style="flex:1;height:32px;border-radius:8px;cursor:pointer;font-size:13px;">' + T.unitCm + '</button>' +
          '<button type="button" data-unit="in" style="flex:1;height:32px;border-radius:8px;cursor:pointer;font-size:13px;">' + T.unitIn + '</button>' +
        '</div>' +
        '<div>' +
          '<div style="font-weight:700;margin-bottom:6px;">' + T.prefQ + '</div>' +
          '<label style="' + radioStyle + '"><input type="radio" name="sh-pref" value="comfort"> ' + T.prefComfort + '</label>' +
          '<label style="' + radioStyle + '"><input type="radio" name="sh-pref" value="sculpted" checked> ' + T.prefSculpted + '</label>' +
          '<label style="' + radioStyle + '"><input type="radio" name="sh-pref" value="snatched"> ' + T.prefSnatched + '</label>' +
        '</div>' +
        '<button class="sh-submit" style="height:44px;border-radius:10px;border:none;background:#111;color:#fff;font-weight:700;cursor:pointer;font-size:15px;">' + T.submit + '</button>' +
        '<div class="sh-result" style="display:none;background:#f5f5f5;border:1px solid #eee;border-radius:12px;padding:12px;"></div>' +
        '<div style="display:flex;gap:16px;">' +
          '<button type="button" class="sh-how" style="' + linkStyle + '">' + T.howLink + '</button>' +
          '<button type="button" class="sh-notape" style="' + linkStyle + '">' + T.noTapeLink + '</button>' +
        '</div>' +
        '<div class="sh-help" style="display:none;background:#fafafa;border:1px solid #eee;border-radius:12px;padding:12px;"></div>' +
      '</div>';
    document.body.appendChild(panel);

    var $ = function (s) { return panel.querySelector(s); };
    var waistIn = $('.sh-waist'), hipIn = $('.sh-hip'), result = $('.sh-result'), help = $('.sh-help');
    var unit = 'cm';

    function renderUnits() {
      panel.querySelectorAll('.sh-units button').forEach(function (b) {
        var on = b.getAttribute('data-unit') === unit;
        b.style.background = on ? '#111' : '#fff';
        b.style.color = on ? '#fff' : '#111';
        b.style.border = '1px solid ' + (on ? '#111' : '#ddd');
      });
      waistIn.placeholder = unit === 'cm' ? (DA ? 'fx 72' : 'e.g. 72') : (DA ? 'fx 28' : 'e.g. 28');
      hipIn.placeholder = unit === 'cm' ? (DA ? 'fx 101' : 'e.g. 101') : (DA ? 'fx 40' : 'e.g. 40');
    }
    panel.querySelectorAll('.sh-units button').forEach(function (b) {
      b.addEventListener('click', function () { unit = b.getAttribute('data-unit'); renderUnits(); });
    });
    renderUnits();

    function submit() {
      var pref = (panel.querySelector('input[name="sh-pref"]:checked') || {}).value;
      var r = ScubalooksSizing.recommend(waistIn.value, hipIn.value, unit, pref);
      var html = '';
      if (r.status === 'invalid') html = T.invalid;
      else if (r.status === 'too_small') html = T.tooSmall;
      else if (r.status === 'too_large') html = T.tooLarge;
      else {
        if (r.stretchXL) html = T.stretchXL;
        else if (r.pref === 'comfort') html = T.bestComfort(r.size);
        else if (r.pref === 'snatched' && r.snatchedSize) html = T.snatchChosen(r.size, r.mainSize);
        else {
          html = T.best(r.mainSize);
          if (r.pref === 'snatched' && r.isSmallest) html += '<br><br>' + T.smallest;
          else if (r.snatchedSize) html += '<br><br>' + T.snatchOption(r.snatchedSize);
        }
        html += '<br><br><span style="color:#888;font-size:12px;">' + T.inseam + '</span>';
      }
      if (r.convertedFromInches) html = '<span style="color:#888;font-size:12px;">' + T.converted + '</span><br>' + html;
      result.innerHTML = html;
      result.style.display = 'block';

      // Optional: lets you track recommendations (e.g. in GA4 / Shopify analytics)
      try { window.dispatchEvent(new CustomEvent('scubalooks:size-recommended', { detail: r })); } catch (e) {}
    }
    $('.sh-submit').addEventListener('click', submit);
    [waistIn, hipIn].forEach(function (el) {
      el.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submit(); } });
    });

    var helpShown = null;
    function toggleHelp(kind) {
      if (helpShown === kind) { help.style.display = 'none'; helpShown = null; return; }
      helpShown = kind;
      help.innerHTML = kind === 'how'
        ? T.how + '<img src="' + MEASURE_IMG + '" alt="" style="width:100%;margin-top:8px;border-radius:8px;">'
        : T.noTape;
      help.style.display = 'block';
    }
    $('.sh-how').addEventListener('click', function () { toggleHelp('how'); });
    $('.sh-notape').addEventListener('click', function () { toggleHelp('notape'); });
    $('.sh-close').addEventListener('click', function () { panel.style.display = 'none'; });

    // ---- Bubble button (Shadow DOM so theme CSS can't break it) ----
    var host = document.createElement('div');
    host.id = 'sizeGuideBubbleHost';
    Object.assign(host.style, {
      position: 'fixed',
      bottom: isMobile ? '80px' : '90px',
      left: isMobile ? '16px' : 'auto',
      right: isMobile ? 'auto' : '20px',
      zIndex: '2147483647',
      pointerEvents: 'none'
    });
    var shadow = host.attachShadow({ mode: 'open' });
    shadow.innerHTML =
      '<style>' +
      ':host{all:initial}*,*::before,*::after{box-sizing:border-box}' +
      '.btn{all:unset;display:inline-block;padding:14px 26px;min-height:44px;border-radius:9999px;' +
      'font-weight:700;font-size:16px;letter-spacing:0.2px;font-family:system-ui,-apple-system,sans-serif;' +
      'line-height:1.2;cursor:pointer;user-select:none;background-color:#9E9A9A;color:#fff;' +
      'box-shadow:0 8px 22px rgba(0,0,0,.25);pointer-events:auto;transition:transform 0.2s;}' +
      '.btn:hover{transform:scale(1.05);}' +
      '@media (max-width:749px){.btn{padding:8px 16px;min-height:36px;font-size:14px;}}' +
      '</style>' +
      '<button id="sg-btn" class="btn">' + T.button + '</button>';
    document.body.appendChild(host);

    shadow.getElementById('sg-btn').addEventListener('click', function () {
      var showing = panel.style.display === 'flex';
      panel.style.display = showing ? 'none' : 'flex';
      if (!showing) waistIn.focus();
    });
  } catch (e) {
    console.error('Size Helper initialization error:', e);
  }
})();